import { getJsApiSignApi } from '@/api/communal'

/**
 * 描述 获取微信jssdk的签名注入wx.config，
 * @date 2020-04-15
 * @returns {any}
 */
function getjsApiSign() {
  return new Promise((reslove, reject) => {
    getJsApiSignApi()
      .then(res => {
        // eslint-disable-next-line no-undef
        wx.config({
          beta: true,
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appid, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ['getLocation'], // 必填，需要使用的JS接口列表
        })
        // eslint-disable-next-line no-undef
        wx.ready((res) => {
          // console.log('config成功', res)
          reslove(res)
        })
        // eslint-disable-next-line no-undef
        wx.error((res) => {
          // console.log('config失败')
          reject()
          // console.log(res)
        })
      })
      .catch(() => {
        reject()
      })
  })
}
/**
 * 描述 微信sdk定位获取用户地理位置 返回经纬度
 * @date 2020-04-15
 * @returns {any}
 */
function getWxLocation() {
  // console.log('微信定位getWxLocation成功开始')
  return new Promise((reslove, reject) => {
    // eslint-disable-next-line no-undef
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        console.log('getWxLocation成功', res)
        const { latitude, longitude } = res
        const coordinate = { latitude, longitude }
        reslove(coordinate)
      },
      fail: function (error) {
        console.log('getWxLocation失败', error)
        reject(error)
      },
      cancel: function (error) {
        console.log('getWxLocation失败', error)
        reject(error)
      },
    })
  })
}
/**
 * 描述 执行获取当前城市流程：注入wx的config，使用wx jsSDK获取当前经纬度，使用高德jspai将经纬度转换成位置信息，返回当前城市
 * @date 2020-04-15
 * @returns {any}
 */
export const getLocation = () => {
  return new Promise((reslove, reject) => {
    getjsApiSign().then(() => {
      reslove(getWxLocation())
    })
  })
}